import React from 'react';
// @ts-ignore
import { Modal, ModalBody, ModalContent, ModalDialog } from 'arag-ui-lib';
import PolicyHolderReviewClaimForm from '../policyHolderReviewClaimForm/policyHolderReviewClaimForm';
import { useTranslation } from 'react-i18next';

type Props = {
    submitting: boolean;
    handleUserInfoSubmit: (values: { email: string; passcode: string }) => void;
};

const PolicyHolderLoginModal = (props: Props): JSX.Element => {
    const { submitting, handleUserInfoSubmit } = props;
    const { t } = useTranslation();
    return (
        <Modal id={'review_claim_modal'} fadeIn={true} darkenedBackground>
            <ModalDialog id={'review_claim_dialog'} size={'lg'}>
                <ModalContent id={'review_claim_content'}>
                    <ModalBody id={'review_claim_body_wrapper'}>
                        <>
                            <h4>{t('reviewClaim') as string}</h4>
                            <PolicyHolderReviewClaimForm
                                submitting={submitting}
                                handleUserInfoSubmit={handleUserInfoSubmit}
                            />
                        </>
                    </ModalBody>
                </ModalContent>
            </ModalDialog>
        </Modal>
    );
};

export default PolicyHolderLoginModal;
